import React, { useEffect, useState } from "react";
function Testimg() {
  const params = window.location.href.split("?");
  const [backendData, setData] = useState();

  useEffect(() => {
    fetchtest();
  }, []);

  const fetchtest = async () => {
    try {
      const res = await fetch("/testimg", {
        method: "POST",
        headers: {
          "content-type": "application/json",
        },
        body: JSON.stringify(params),
      });

      const data = await res.json();
      setData(data);
    } catch (error) {
      console.log(error);
    }
  };

  const sharimg = (product, id) => {
    if (!window.confirm("האם אתה בטוח באישור התמונה?")) return;
    const jsonData = { product, id };

    fetch("/shar-imgtest", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(jsonData),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.isToken) {
          alert("התמונה אושרה בהצלחה");
          window.location = "/";
        } else {
          alert("התמונה לא אושרה בהצלחה");
          window.location = "/";
        }
      });
  };

  const deleteimg = (product, id) => {
    if (!window.confirm("האם אתה בטוח במחיקת התמונה?")) return;
    const jsonData = { product, id };

    fetch("/delete-imgtest", {
      method: "POST",
      headers: {
        "content-type": "application/json",
      },
      body: JSON.stringify(jsonData),
    })
      .then((res) => res.json())
      .then((res) => {
        if (res.isToken) {
          alert("התמונה נמחקה בהצלחה");
        } else {
          alert("התמונה לא נמחקה בהצלחה");
        }
      });
  };

  return (
    <div className="container text-center py-5">
      {typeof backendData === "undefined" ? (
        <p className="text-muted">טוען נתונים...</p>
      ) : (
        <div className="card shadow-sm p-4">
          <h3 className="mb-4">אישור / מחיקת תמונה</h3>
          <img
            src={backendData.url}
            alt="תצוגת תמונה"
            id="idimg"
            className="img-fluid mb-4 rounded"
            style={{ maxHeight: "400px" }}
          />
          <div className="d-flex justify-content-center gap-3">
            <button
              className="btn btn-success"
              onClick={() => sharimg(backendData.product, backendData.isToken)}
            >
              אישור תמונה
            </button>
            <button
              className="btn btn-danger"
              onClick={() => deleteimg(backendData.product, backendData.isToken)}
            >
              מחיקת התמונה
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Testimg;
